// Runtime config for the new Xlooop frontend. All backend truth comes from api.xlooop.com; Clerk provides
// auth via the `xlooop-workers` JWT template. In dev with no Clerk key (or VITE_USE_MSW=1), the app runs
// against MSW fixtures so the UI previews without live auth/backend.

const env = import.meta.env;

/** Absolute API base — the deployed worker. Mirrors the legacy `apiBaseUrl()` default. */
export const API_BASE: string = (env.VITE_API_BASE as string | undefined) || 'https://api.xlooop.com';

/** Clerk publishable key (public). Required for real auth; absent → dev/MSW mode. */
export const CLERK_PUBLISHABLE_KEY: string = (env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined) || '';

/** The JWT template the worker's clerkAuth expects (see legacy api-auth.ts authHeaders). */
export const CLERK_TOKEN_TEMPLATE = 'xlooop-workers';

/** Use MSW fixtures instead of the live backend. On when explicitly set OR when no Clerk key in dev. */
export const USE_MSW: boolean =
  env.VITE_USE_MSW === '1' || (import.meta.env.DEV && !CLERK_PUBLISHABLE_KEY);

export const IS_DEV: boolean = !!import.meta.env.DEV;
